import { Switch } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import type { CreativeVariant } from '../model';

/** The creative's variants with an active switch each; `onToggle` gets the variant's index. */
export function CreativeVariantsList({
  variants,
  onToggle,
}: {
  variants: CreativeVariant[];
  onToggle: (index: number, active: boolean) => void;
}) {
  return (
    <div className="border-border divide-border divide-y rounded-md border">
      {variants.length ? (
        variants.map((variant, index) => (
          <div
            // Variants have no guaranteed id; the index only disambiguates id-less ones. The list
            // is never reordered or filtered here, and toggles address variants by index.
            // react-doctor-disable-next-line react-doctor/no-array-index-as-key
            key={variant.id ?? `${variant.fileName ?? 'variant'}-${String(index)}`}
            className="flex items-center gap-4 p-3 text-sm"
          >
            <span className="min-w-0 flex-1 truncate">
              {variant.fileName ?? variant.url ?? '-'}
            </span>
            <span className="text-muted-foreground whitespace-nowrap">
              {variant.width && variant.height
                ? `${String(variant.width)} x ${String(variant.height)}`
                : '-'}
            </span>
            <Switch
              checked={variant.active ?? false}
              aria-label={variant.fileName ?? dashboardT('creatives.variants')}
              onCheckedChange={(active) => {
                onToggle(index, active);
              }}
            />
          </div>
        ))
      ) : (
        <p className="text-muted-foreground p-6 text-center text-sm">
          {dashboardT('creatives.empty')}
        </p>
      )}
    </div>
  );
}
